import React from 'react'
import { AlertBGIcon, CameraBGIcon, DeleteShape, FileIcon, MediaIcon, MiceBGIcon, UserAvatarIcon } from '../../assets/images'
import { frontDateConverter } from '../../utils/utils';

const AlertEvidenceList = ({ item, EvidenceOnClick, downloadFile }) => {
    console.log("EvidenceList", item);
    return (
        <div style={{marginBottom: '1rem'}}  key={item.IncReportDocsID}>
            <div className="" style={{ flexDirection: 'column' }}>
                <div style={{ borderRadius: '0.5rem', boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px", padding: '0.5rem' }} >
                <div>
                {
                    (item.AttachedDocTitle.includes(".png") || item.AttachedDocTitle.includes(".jpg") || item.AttachedDocTitle.includes(".jpeg"))
                        ?
                        <img id={"evidenceimg_" + item.IncReportDocsID} src={CameraBGIcon} alt="camera bg icon" />
                        :
                        ( item.AttachedDocTitle.includes(".mp3") || item.AttachedDocTitle.includes(".wav"))
                            ?
                            <img id={"evidenceimg_" + item.IncReportDocsID} src={MiceBGIcon} alt="mice icon" />
                            :
                            (item.AttachedDocTitle.includes(".mp4") || item.AttachedDocTitle.includes(".mov") || item.AttachedDocTitle.includes(".avi"))
                                ?
                                <img id={"evidenceimg_" + item.IncReportDocsID} src={MediaIcon} alt="media icon" />
                                :
                                (item.AttachedDocTitle.includes("Alert Id : "))
                                    ?
                                    <img id={"evidenceimg_" + item.IncReportDocsID} src={AlertBGIcon} alt="alert icon" />
                                    :
                                    (item.AttachedDocTitle.includes(".pdf") || item.AttachedDocTitle.includes(".docx") || item.AttachedDocTitle.includes(".txt"))
                                    ?
                                    <img id={"evidenceimg_" + item.IncReportDocsID} height="20" width="22" style={{ marginRight: '0.1rem' }} src={FileIcon} alt="user icon" />
                                    :
                                    <img id={"evidenceimg_" + item.IncReportDocsID} height="20" width="22" style={{ marginRight: '0.1rem' }} src={UserAvatarIcon} alt="user icon" />
                }
                <span id={"txt_" + item.IncReportDocsID} style={{marginLeft: '0.5rem', cursor: item.DocType === "Comment" ? 'default' : 'pointer' }} className="" onClick={() => {
                    if(item.DocType !== "Comment"){
                        // EvidenceOnClick(item.AttachedDocTitle, item.DocumentURL)
                        downloadFile(item.AttachedDocTitle, item.DocumentURL)
                    }
                }}>{item.AttachedDocTitle}</span>
                </div>
                <p className='OperateBy' style={{fontSize: 'x-small', marginBottom: '0'}}>Attached by: <span style={{fontSize: '0.6rem'}} className='OperateName ml-1'>{item.Username}</span></p>
                <p className='OperateBy' style={{fontSize: 'x-small', marginBottom: '0'}}>Attached on: <span style={{fontSize: '0.6rem'}} className='OperateName ml-1'>{frontDateConverter(item.ConvertedDate)}</span></p>
                </div>

            </div>
            {/* <img id={"del_" + item.IncReportDocsID} className="icon-hover" src={DeleteShape} 
            // onClick={() => DeleteEvidence(item)} 
            alt="delete icon"/> */}
        </div>
    )
}

export default AlertEvidenceList